import React from 'react';
import { SRadioGroup } from './RadioGroupSwitcher.styles';
import { TRadioGroupSwitcher } from './RadioGroupSwitcher.types';

const RadioGroupSwitcher = ({ options, ...props }: TRadioGroupSwitcher) => {
  return <SRadioGroup options={options} optionType="button" {...props} />;
};

export { RadioGroupSwitcher };
